import { imageStore } from '../images.js';
import Drawable from './Drawable.js';
import Sprite from '../ui/Sprite.js';
import ItemFactory from './ItemFactory.js';

export default class OverworldItem extends Drawable {
    serialize() {
        console.log(`Serializing ${this.constructor.name}`);
        return {
            itemId: this.item.id,
            acquired: this.acquired,
            position: this.position,
            visible: this.visible,
            identifier: this.identifier,
        };
    }

    static deserialize(data) {
        return new OverworldItem({
            item: ItemFactory.create(data.itemId),
            acquired: data.acquired,
            position: data.position,
            visible: data.visible,
            identifier: data.identifier ?? null,
        });
    }

    constructor({ item, acquired, position, visible = true, identifier = null }) {
        super({ position });
        this.item = item;
        this.acquired = acquired;
        this.visible = visible;
        this.identifier = identifier;
        this.sprite = new Sprite({
            position: this.position,
            image: imageStore.get('img/items/overworld_item.png'),
            moving: false,
            visible: this.visible,
        });
        this.interactionPriority = 10;
    }

    canInteract() {
        return !this.acquired;
    }

    endInteraction() {}

    draw() {
        if (!this.visible) return;
        this.sprite.position = this.effectivePosition();
        this.sprite.draw();
    }
}
